import React, { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./configs/route.config";
import ReactGA from "react-ga4";
import ScrollToTop from "./utils/scrollToTop";

import "./styles/app.scss";

function App() {
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <Suspense>
        <Routes>
          {routes?.map((route, index) => {
            const { layout: Layout, path, element: Element } = route;
            return (
              <Route
                key={index}
                path={path}
                element={
                  <Layout>
                    <Element />
                  </Layout>
                }
              />
            );
          })}
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
